import React from "react";

import SettingsTabs from "superAdminViews/setting/SettingsTabs";
import Brands from "./Brands";
import CarTypes from "./CarTypes";
import Colors from "./Colors";
import Models from "./Models";

// `render={() => <Brands key={Math.random()} />}` used to sit on every
// one of these, which threw the screen away and rebuilt it on each
// render of the parent — losing filters and refetching everything.
const TABS = [
  { path: "/brands", label: "Brands", component: Brands },
  { path: "/models", label: "Models", component: Models },
  { path: "/carTypes", label: "Car types", component: CarTypes },
  { path: "/colors", label: "Colours", component: Colors },
];

/**
 * CarOptions - the vocabulary drivers pick from when adding a vehicle.
 */
const CarOptions = () => (
  <SettingsTabs
    title="Vehicle options"
    description="The brands, models, types and colours drivers choose from."
    base="/superAdmin/vehicleOptions"
    tabs={TABS}
  />
);

export default CarOptions;
